/**************************************************
 * Nombre:       IconoTexto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const IconoTexto = ({Icono, texto, click}) => {

    return (
        <Grid
            onClick={() => click()}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{fill: '#fff', color: '#fff'}}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                <Icono/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                <Typography sx={{fontSize: 10,textAlign: 'center', lineHeight: 1.1}} >{texto}</Typography>
            </Grid>

        </Grid>
    )

}
export default IconoTexto